var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "piedra",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito pulido",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita pulida",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita pulida",
  "block.minecraft.grass_block": "bloque de pasto",
  "block.minecraft.dirt": "tierra",
  "block.minecraft.coarse_dirt": "tierra infértil",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "nilio carmesí",
  "block.minecraft.warped_nylium": "nilio distorsionado",
  "block.minecraft.cobblestone": "adoquín",
  "block.minecraft.oak_planks": "madera de roble",
  "block.minecraft.spruce_planks": "madera de abeto",
  "block.minecraft.birch_planks": "madera de abedul",
  "block.minecraft.jungle_planks": "madera de jungla",
  "block.minecraft.acacia_planks": "madera de acacia",
  "block.minecraft.dark_oak_planks": "madera de roble oscuro",
  "block.minecraft.crimson_planks": "madera carmesí",
  "block.minecraft.warped_planks": "madera distorsionada",
  "block.minecraft.oak_sapling": "brote de roble",
  "block.minecraft.spruce_sapling": "brote de abeto",
  "block.minecraft.birch_sapling": "brote de abedul",
  "block.minecraft.jungle_sapling": "brote de jungla",
  "block.minecraft.acacia_sapling": "brote de acacia",
  "block.minecraft.dark_oak_sapling": "brote de roble oscuro",
  "block.minecraft.bedrock": "piedra madre",
  "block.minecraft.sand": "arena",
  "block.minecraft.red_sand": "arena rojiza",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "mineral de oro",
  "block.minecraft.iron_ore": "mineral de hierro",
  "block.minecraft.coal_ore": "mineral de carbón",
  "block.minecraft.nether_gold_ore": "mineral de oro del nether",
  "block.minecraft.oak_log": "tronco de roble",
  "block.minecraft.spruce_log": "tronco de abeto",
  "block.minecraft.birch_log": "tronco de abedul",
  "block.minecraft.jungle_log": "tronco de jungla",
  "block.minecraft.acacia_log": "tronco de acacia",
  "block.minecraft.dark_oak_log": "tronco de roble oscuro",
  "block.minecraft.crimson_stem": "tallo carmesí",
  "block.minecraft.warped_stem": "tallo distorsionado",
  "block.minecraft.stripped_oak_log": "tronco de roble sin corteza",
  "block.minecraft.stripped_spruce_log": "tronco de abeto sin corteza",
  "block.minecraft.stripped_birch_log": "tronco de abedul sin corteza",
  "block.minecraft.stripped_jungle_log": "tronco de jungla sin corteza",
  "block.minecraft.stripped_acacia_log": "tronco de acacia sin corteza",
  "block.minecraft.stripped_dark_oak_log": "tronco de roble oscuro sin corteza",
  "block.minecraft.stripped_crimson_stem": "tallo carmesí sin corteza",
  "block.minecraft.stripped_warped_stem": "tallo distorsionado sin corteza",
  "block.minecraft.stripped_oak_wood": "leño de roble sin corteza",
  "block.minecraft.stripped_spruce_wood": "leño de abeto sin corteza",
  "block.minecraft.stripped_birch_wood": "leño de abedul sin corteza",
  "block.minecraft.stripped_jungle_wood": "leño de jungla sin corteza",
  "block.minecraft.stripped_acacia_wood": "leño de acacia sin corteza",
  "block.minecraft.stripped_dark_oak_wood": "leño de roble oscuro sin corteza",
  "block.minecraft.stripped_crimson_hyphae": "hifas carmesí sin corteza",
  "block.minecraft.stripped_warped_hyphae": "hifas distorsionadas sin corteza",
  "block.minecraft.oak_wood": "leño de roble",
  "block.minecraft.spruce_wood": "leño de abeto",
  "block.minecraft.birch_wood": "leño de abedul",
  "block.minecraft.jungle_wood": "leño de jungla",
  "block.minecraft.acacia_wood": "leño de acacia",
  "block.minecraft.dark_oak_wood": "leño de roble oscuro",
  "block.minecraft.crimson_hyphae": "hifas carmesí",
  "block.minecraft.warped_hyphae": "hifas distorsionadas",
  "block.minecraft.oak_leaves": "hojas de roble",
  "block.minecraft.spruce_leaves": "hojas de abeto",
  "block.minecraft.birch_leaves": "hojas de abedul",
  "block.minecraft.jungle_leaves": "hojas de jungla",
  "block.minecraft.acacia_leaves": "hojas de acacia",
  "block.minecraft.dark_oak_leaves": "hojas de roble oscuro",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja húmeda",
  "block.minecraft.glass": "vidrio",
  "block.minecraft.lapis_ore": "mineral de lapislázuli",
  "block.minecraft.lapis_block": "bloque de lapislázuli",
  "block.minecraft.dispenser": "dispensador",
  "block.minecraft.sandstone": "arenisca",
  "block.minecraft.chiseled_sandstone": "arenisca cincelada",
  "block.minecraft.cut_sandstone": "arenisca cortada",
  "block.minecraft.note_block": "bloque musical",
  "block.minecraft.powered_rail": "vía propulsora",
  "block.minecraft.detector_rail": "vía detectora",
  "block.minecraft.sticky_piston": "pistón pegajoso",
  "block.minecraft.cobweb": "telaraña",
  "block.minecraft.grass": "pasto",
  "block.minecraft.fern": "helecho",
  "block.minecraft.dead_bush": "arbusto muerto",
  "block.minecraft.seagrass": "planta marina",
  "block.minecraft.sea_pickle": "pepino de mar",
  "block.minecraft.piston": "pistón",
  "block.minecraft.white_wool": "lana blanca",
  "block.minecraft.orange_wool": "lana naranja",
  "block.minecraft.magenta_wool": "lana magenta",
  "block.minecraft.light_blue_wool": "lana celeste",
  "block.minecraft.yellow_wool": "lana amarilla",
  "block.minecraft.lime_wool": "lana verde lima",
  "block.minecraft.pink_wool": "lana rosa",
  "block.minecraft.gray_wool": "lana gris",
  "block.minecraft.light_gray_wool": "lana gris claro",
  "block.minecraft.cyan_wool": "lana cian",
  "block.minecraft.purple_wool": "lana violeta",
  "block.minecraft.blue_wool": "lana azul",
  "block.minecraft.brown_wool": "lana marrón",
  "block.minecraft.green_wool": "lana verde",
  "block.minecraft.red_wool": "lana roja",
  "block.minecraft.black_wool": "lana negra",
  "block.minecraft.dandelion": "diente de león",
  "block.minecraft.poppy": "amapola",
  "block.minecraft.blue_orchid": "orquídea azul",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "rubiácea",
  "block.minecraft.red_tulip": "tulipán rojo",
  "block.minecraft.orange_tulip": "tulipán naranja",
  "block.minecraft.white_tulip": "tulipán blanco",
  "block.minecraft.pink_tulip": "tulipán rosa",
  "block.minecraft.oxeye_daisy": "margarita",
  "block.minecraft.cornflower": "aciano",
  "block.minecraft.lily_of_the_valley": "lirio del valle",
  "block.minecraft.wither_rose": "rosa del wither",
  "block.minecraft.brown_mushroom": "hongo marrón",
  "block.minecraft.red_mushroom": "hongo rojo",
  "block.minecraft.crimson_fungus": "hongo carmesí",
  "block.minecraft.warped_fungus": "hongo distorsionado",
  "block.minecraft.crimson_roots": "yuyos carmesí",
  "block.minecraft.warped_roots": "yuyos distorsionados",
  "block.minecraft.nether_sprouts": "brotes del nether",
  "block.minecraft.weeping_vines": "enredaderas lloronas",
  "block.minecraft.twisting_vines": "enredaderas retorcidas",
  "block.minecraft.sugar_cane": "caña de azúcar",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloque de oro",
  "block.minecraft.iron_block": "bloque de hierro",
  "block.minecraft.oak_slab": "baldosa de roble",
  "block.minecraft.spruce_slab": "baldosa de abeto",
  "block.minecraft.birch_slab": "baldosa de abedul",
  "block.minecraft.jungle_slab": "baldosa de jungla",
  "block.minecraft.acacia_slab": "baldosa de acacia",
  "block.minecraft.dark_oak_slab": "baldosa de roble oscuro",
  "block.minecraft.crimson_slab": "baldosa carmesí",
  "block.minecraft.warped_slab": "baldosa distorsionada",
  "block.minecraft.stone_slab": "baldosa de piedra",
  "block.minecraft.smooth_stone_slab": "baldosa de piedra lisa",
  "block.minecraft.sandstone_slab": "baldosa de arenisca",
  "block.minecraft.cut_sandstone_slab": "baldosa de arenisca cortada",
  "block.minecraft.petrified_oak_slab": "baldosa de roble petrificada",
  "block.minecraft.cobblestone_slab": "baldosa de adoquín",
  "block.minecraft.brick_slab": "baldosa de ladrillos",
  "block.minecraft.stone_brick_slab": "baldosa de ladrillos de piedra",
  "block.minecraft.nether_brick_slab": "baldosa de ladrillos del nether",
  "block.minecraft.quartz_slab": "baldosa de cuarzo",
  "block.minecraft.red_sandstone_slab": "baldosa de arenisca rojiza",
  "block.minecraft.cut_red_sandstone_slab": "baldosa de arenisca rojiza cortada",
  "block.minecraft.purpur_slab": "baldosa de púrpur",
  "block.minecraft.prismarine_slab": "baldosa de prismarina",
  "block.minecraft.prismarine_brick_slab": "baldosa de ladrillos de prismarina",
  "block.minecraft.dark_prismarine_slab": "baldosa de prismarina oscura",
  "block.minecraft.smooth_quartz": "cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "arenisca rojiza lisa",
  "block.minecraft.smooth_sandstone": "arenisca lisa",
  "block.minecraft.smooth_stone": "piedra lisa",
  "block.minecraft.bricks": "ladrillos",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "biblioteca",
  "block.minecraft.mossy_cobblestone": "adoquín musgoso",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "antorcha",
  "block.minecraft.end_rod": "vara del end",
  "block.minecraft.chorus_plant": "chorus",
  "block.minecraft.chorus_flower": "flor de chorus",
  "block.minecraft.purpur_block": "púrpur",
  "block.minecraft.purpur_pillar": "columna de púrpur",
  "block.minecraft.purpur_stairs": "escaleras de púrpur",
  "block.minecraft.spawner": "generador",
  "block.minecraft.oak_stairs": "escaleras de roble",
  "block.minecraft.chest": "cofre",
  "block.minecraft.diamond_ore": "mineral de diamante",
  "block.minecraft.diamond_block": "bloque de diamante",
  "block.minecraft.crafting_table": "mesa de crafteo",
  "block.minecraft.farmland": "tierra de cultivo",
  "block.minecraft.furnace": "horno",
  "block.minecraft.ladder": "escalera",
  "block.minecraft.rail": "vía",
  "block.minecraft.cobblestone_stairs": "escaleras de adoquín",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa de presión de piedra",
  "block.minecraft.oak_pressure_plate": "placa de presión de roble",
  "block.minecraft.spruce_pressure_plate": "placa de presión de abeto",
  "block.minecraft.birch_pressure_plate": "placa de presión de abedul",
  "block.minecraft.jungle_pressure_plate": "placa de presión de jungla",
  "block.minecraft.acacia_pressure_plate": "placa de presión de acacia",
  "block.minecraft.dark_oak_pressure_plate": "placa de presión de roble oscuro",
  "block.minecraft.crimson_pressure_plate": "placa de presión carmesí",
  "block.minecraft.warped_pressure_plate": "placa de presión distorsionada",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de presión de piedra negra pulida",
  "block.minecraft.redstone_ore": "mineral de redstone",
  "block.minecraft.redstone_torch": "antorcha de redstone",
  "block.minecraft.snow": "nieve",
  "block.minecraft.ice": "hielo",
  "block.minecraft.snow_block": "bloque de nieve",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "arcilla",
  "block.minecraft.jukebox": "tocadiscos",
  "block.minecraft.oak_fence": "valla de roble",
  "block.minecraft.spruce_fence": "valla de abeto",
  "block.minecraft.birch_fence": "valla de abedul",
  "block.minecraft.jungle_fence": "valla de jungla",
  "block.minecraft.acacia_fence": "valla de acacia",
  "block.minecraft.dark_oak_fence": "valla de roble oscuro",
  "block.minecraft.crimson_fence": "valla carmesí",
  "block.minecraft.warped_fence": "valla distorsionada",
  "block.minecraft.pumpkin": "zapallo",
  "block.minecraft.carved_pumpkin": "zapallo esculpido",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "arena de almas",
  "block.minecraft.soul_soil": "tierra de almas",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto pulido",
  "block.minecraft.soul_torch": "antorcha de almas",
  "block.minecraft.glowstone": "piedra luminosa",
  "block.minecraft.jack_o_lantern": "zapallo de halloween",
  "block.minecraft.oak_trapdoor": "escotilla de roble",
  "block.minecraft.spruce_trapdoor": "escotilla de abeto",
  "block.minecraft.birch_trapdoor": "escotilla de abedul",
  "block.minecraft.jungle_trapdoor": "escotilla de jungla",
  "block.minecraft.acacia_trapdoor": "escotilla de acacia",
  "block.minecraft.dark_oak_trapdoor": "escotilla de roble oscuro",
  "block.minecraft.crimson_trapdoor": "escotilla carmesí",
  "block.minecraft.warped_trapdoor": "escotilla distorsionada",
  "block.minecraft.infested_stone": "piedra infestada",
  "block.minecraft.infested_cobblestone": "adoquín infestado",
  "block.minecraft.infested_stone_bricks": "ladrillos de piedra infestados",
  "block.minecraft.infested_mossy_stone_bricks": "ladrillos de piedra musgosos infestados",
  "block.minecraft.infested_cracked_stone_bricks": "ladrillos de piedra quebrados infestados",
  "block.minecraft.infested_chiseled_stone_bricks": "ladrillos de piedra cincelados infestados",
  "block.minecraft.stone_bricks": "ladrillos de piedra",
  "block.minecraft.mossy_stone_bricks": "ladrillos de piedra musgosos",
  "block.minecraft.cracked_stone_bricks": "ladrillos de piedra quebrados",
  "block.minecraft.chiseled_stone_bricks": "ladrillos de piedra cincelados",
  "block.minecraft.brown_mushroom_block": "bloque de hongo marrón",
  "block.minecraft.red_mushroom_block": "bloque de hongo rojo",
  "block.minecraft.mushroom_stem": "tallo de hongo",
  "block.minecraft.iron_bars": "barrotes de hierro",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panel de vidrio",
  "block.minecraft.melon": "sandía",
  "block.minecraft.vine": "enredaderas",
  "block.minecraft.oak_fence_gate": "puerta de valla de roble",
  "block.minecraft.spruce_fence_gate": "puerta de valla de abeto",
  "block.minecraft.birch_fence_gate": "puerta de valla de abedul",
  "block.minecraft.jungle_fence_gate": "puerta de valla de jungla",
  "block.minecraft.acacia_fence_gate": "puerta de valla de acacia",
  "block.minecraft.dark_oak_fence_gate": "puerta de valla de roble oscuro",
  "block.minecraft.crimson_fence_gate": "puerta de valla carmesí",
  "block.minecraft.warped_fence_gate": "puerta de valla distorsionada",
  "block.minecraft.brick_stairs": "escaleras de ladrillos",
  "block.minecraft.stone_brick_stairs": "escaleras de ladrillos de piedra",
  "block.minecraft.mycelium": "micelio",
  "block.minecraft.lily_pad": "lirio de agua",
  "block.minecraft.nether_bricks": "ladrillos del nether",
  "block.minecraft.cracked_nether_bricks": "ladrillos del nether quebrados",
  "block.minecraft.chiseled_nether_bricks": "ladrillos del nether cincelados",
  "block.minecraft.nether_brick_fence": "valla de ladrillos del nether",
  "block.minecraft.nether_brick_stairs": "escaleras de ladrillos del nether",
  "block.minecraft.enchanting_table": "mesa de encantamientos",
  "block.minecraft.end_portal_frame": "marco del portal del end",
  "block.minecraft.end_stone": "piedra del end",
  "block.minecraft.end_stone_bricks": "ladrillos de piedra del end",
  "block.minecraft.dragon_egg": "huevo de dragón",
  "block.minecraft.redstone_lamp": "lámpara de redstone",
  "block.minecraft.sandstone_stairs": "escaleras de arenisca",
  "block.minecraft.emerald_ore": "mineral de esmeralda",
  "block.minecraft.ender_chest": "cofre de ender",
  "block.minecraft.tripwire_hook": "gancho de hilo",
  "block.minecraft.emerald_block": "bloque de esmeralda",
  "block.minecraft.spruce_stairs": "escaleras de abeto",
  "block.minecraft.birch_stairs": "escaleras de abedul",
  "block.minecraft.jungle_stairs": "escaleras de jungla",
  "block.minecraft.crimson_stairs": "escaleras carmesí",
  "block.minecraft.warped_stairs": "escaleras distorsionadas",
  "block.minecraft.command_block": "bloque de comandos",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "pared de adoquín",
  "block.minecraft.mossy_cobblestone_wall": "pared de adoquín musgoso",
  "block.minecraft.brick_wall": "pared de ladrillos",
  "block.minecraft.prismarine_wall": "pared de prismarina",
  "block.minecraft.red_sandstone_wall": "pared de arenisca rojiza",
  "block.minecraft.mossy_stone_brick_wall": "pared de ladrillos de piedra musgosos",
  "block.minecraft.granite_wall": "pared de granito",
  "block.minecraft.stone_brick_wall": "pared de ladrillos de piedra",
  "block.minecraft.nether_brick_wall": "pared de ladrillos del nether",
  "block.minecraft.andesite_wall": "pared de andesita",
  "block.minecraft.red_nether_brick_wall": "pared de ladrillos del nether rojos",
  "block.minecraft.sandstone_wall": "pared de arenisca",
  "block.minecraft.end_stone_brick_wall": "pared de ladrillos de piedra del end",
  "block.minecraft.diorite_wall": "pared de diorita",
  "block.minecraft.blackstone_wall": "pared de piedra negra",
  "block.minecraft.polished_blackstone_wall": "pared de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_wall": "pared de ladrillos de piedra negra pulida",
  "block.minecraft.stone_button": "botón de piedra",
  "block.minecraft.oak_button": "botón de roble",
  "block.minecraft.spruce_button": "botón de abeto",
  "block.minecraft.birch_button": "botón de abedul",
  "block.minecraft.jungle_button": "botón de jungla",
  "block.minecraft.acacia_button": "botón de acacia",
  "block.minecraft.dark_oak_button": "botón de roble oscuro",
  "block.minecraft.crimson_button": "botón carmesí",
  "block.minecraft.warped_button": "botón distorsionado",
  "block.minecraft.polished_blackstone_button": "botón de piedra negra pulida",
  "block.minecraft.anvil": "yunque",
  "block.minecraft.chipped_anvil": "yunque dañado",
  "block.minecraft.damaged_anvil": "yunque muy dañado",
  "block.minecraft.trapped_chest": "cofre con trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de presión ponderada (ligera)",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de presión ponderada (pesada)",
  "block.minecraft.daylight_detector": "sensor de luz solar",
  "block.minecraft.redstone_block": "bloque de redstone",
  "block.minecraft.nether_quartz_ore": "mineral de cuarzo del nether",
  "block.minecraft.hopper": "tolva",
  "block.minecraft.chiseled_quartz_block": "cuarzo cincelado",
  "block.minecraft.quartz_block": "cuarzo",
  "block.minecraft.quartz_bricks": "ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "columna de cuarzo",
  "block.minecraft.quartz_stairs": "escaleras de cuarzo",
  "block.minecraft.activator_rail": "vía activadora",
  "block.minecraft.dropper": "soltador",
  "block.minecraft.white_terracotta": "terracota blanca",
  "block.minecraft.orange_terracotta": "terracota naranja",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota celeste",
  "block.minecraft.yellow_terracotta": "terracota amarilla",
  "block.minecraft.lime_terracotta": "terracota verde lima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota gris",
  "block.minecraft.light_gray_terracotta": "terracota gris claro",
  "block.minecraft.cyan_terracotta": "terracota cian",
  "block.minecraft.purple_terracotta": "terracota violeta",
  "block.minecraft.blue_terracotta": "terracota azul",
  "block.minecraft.brown_terracotta": "terracota marrón",
  "block.minecraft.green_terracotta": "terracota verde",
  "block.minecraft.red_terracotta": "terracota roja",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "escotilla de hierro",
  "block.minecraft.hay_block": "bloque de heno",
  "block.minecraft.white_carpet": "alfombra blanca",
  "block.minecraft.orange_carpet": "alfombra naranja",
  "block.minecraft.magenta_carpet": "alfombra magenta",
  "block.minecraft.light_blue_carpet": "alfombra celeste",
  "block.minecraft.yellow_carpet": "alfombra amarilla",
  "block.minecraft.lime_carpet": "alfombra verde lima",
  "block.minecraft.pink_carpet": "alfombra rosa",
  "block.minecraft.gray_carpet": "alfombra gris",
  "block.minecraft.light_gray_carpet": "alfombra gris claro",
  "block.minecraft.cyan_carpet": "alfombra cian",
  "block.minecraft.purple_carpet": "alfombra violeta",
  "block.minecraft.blue_carpet": "alfombra azul",
  "block.minecraft.brown_carpet": "alfombra marrón",
  "block.minecraft.green_carpet": "alfombra verde",
  "block.minecraft.red_carpet": "alfombra roja",
  "block.minecraft.black_carpet": "alfombra negra",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloque de carbón",
  "block.minecraft.packed_ice": "hielo comprimido",
  "block.minecraft.acacia_stairs": "escaleras de acacia",
  "block.minecraft.dark_oak_stairs": "escaleras de roble oscuro",
  "block.minecraft.slime_block": "bloque de slime",
  "block.minecraft.grass_path": "camino de pasto",
  "block.minecraft.sunflower": "girasol",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "rosal",
  "block.minecraft.peony": "peonía",
  "block.minecraft.tall_grass": "pasto alto",
  "block.minecraft.large_fern": "helecho alto",
  "block.minecraft.white_stained_glass": "vidrio blanco",
  "block.minecraft.orange_stained_glass": "vidrio naranja",
  "block.minecraft.magenta_stained_glass": "vidrio magenta",
  "block.minecraft.light_blue_stained_glass": "vidrio celeste",
  "block.minecraft.yellow_stained_glass": "vidrio amarillo",
  "block.minecraft.lime_stained_glass": "vidrio verde lima",
  "block.minecraft.pink_stained_glass": "vidrio rosa",
  "block.minecraft.gray_stained_glass": "vidrio gris",
  "block.minecraft.light_gray_stained_glass": "vidrio gris claro",
  "block.minecraft.cyan_stained_glass": "vidrio cian",
  "block.minecraft.purple_stained_glass": "vidrio violeta",
  "block.minecraft.blue_stained_glass": "vidrio azul",
  "block.minecraft.brown_stained_glass": "vidrio marrón",
  "block.minecraft.green_stained_glass": "vidrio verde",
  "block.minecraft.red_stained_glass": "vidrio rojo",
  "block.minecraft.black_stained_glass": "vidrio negro",
  "block.minecraft.white_stained_glass_pane": "panel de vidrio blanco",
  "block.minecraft.orange_stained_glass_pane": "panel de vidrio naranja",
  "block.minecraft.magenta_stained_glass_pane": "panel de vidrio magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel de vidrio celeste",
  "block.minecraft.yellow_stained_glass_pane": "panel de vidrio amarillo",
  "block.minecraft.lime_stained_glass_pane": "panel de vidrio verde lima",
  "block.minecraft.pink_stained_glass_pane": "panel de vidrio rosa",
  "block.minecraft.gray_stained_glass_pane": "panel de vidrio gris",
  "block.minecraft.light_gray_stained_glass_pane": "panel de vidrio gris claro",
  "block.minecraft.cyan_stained_glass_pane": "panel de vidrio cian",
  "block.minecraft.purple_stained_glass_pane": "panel de vidrio violeta",
  "block.minecraft.blue_stained_glass_pane": "panel de vidrio azul",
  "block.minecraft.brown_stained_glass_pane": "panel de vidrio marrón",
  "block.minecraft.green_stained_glass_pane": "panel de vidrio verde",
  "block.minecraft.red_stained_glass_pane": "panel de vidrio rojo",
  "block.minecraft.black_stained_glass_pane": "panel de vidrio negro",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "ladrillos de prismarina",
  "block.minecraft.dark_prismarine": "prismarina oscura",
  "block.minecraft.prismarine_stairs": "escaleras de prismarina",
  "block.minecraft.prismarine_brick_stairs": "escaleras de ladrillos de prismarina",
  "block.minecraft.dark_prismarine_stairs": "escaleras de prismarina oscura",
  "block.minecraft.sea_lantern": "linterna del mar",
  "block.minecraft.red_sandstone": "arenisca rojiza",
  "block.minecraft.chiseled_red_sandstone": "arenisca rojiza cincelada",
  "block.minecraft.cut_red_sandstone": "arenisca rojiza cortada",
  "block.minecraft.red_sandstone_stairs": "escaleras de arenisca rojiza",
  "block.minecraft.repeating_command_block": "bloque de comandos de repetición",
  "block.minecraft.chain_command_block": "bloque de comandos en cadena",
  "block.minecraft.magma_block": "bloque de magma",
  "block.minecraft.nether_wart_block": "bloque de verrugas del nether",
  "block.minecraft.warped_wart_block": "bloque de verrugas distorsionadas",
  "block.minecraft.red_nether_bricks": "ladrillos del nether rojos",
  "block.minecraft.bone_block": "bloque de huesos",
  "block.minecraft.structure_void": "vacío de estructuras",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caja de shulker",
  "block.minecraft.white_shulker_box": "caja de shulker blanca",
  "block.minecraft.orange_shulker_box": "caja de shulker naranja",
  "block.minecraft.magenta_shulker_box": "caja de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "caja de shulker celeste",
  "block.minecraft.yellow_shulker_box": "caja de shulker amarilla",
  "block.minecraft.lime_shulker_box": "caja de shulker verde lima",
  "block.minecraft.pink_shulker_box": "caja de shulker rosa",
  "block.minecraft.gray_shulker_box": "caja de shulker gris",
  "block.minecraft.light_gray_shulker_box": "caja de shulker gris claro",
  "block.minecraft.cyan_shulker_box": "caja de shulker cian",
  "block.minecraft.purple_shulker_box": "caja de shulker violeta",
  "block.minecraft.blue_shulker_box": "caja de shulker azul",
  "block.minecraft.brown_shulker_box": "caja de shulker marrón",
  "block.minecraft.green_shulker_box": "caja de shulker verde",
  "block.minecraft.red_shulker_box": "caja de shulker roja",
  "block.minecraft.black_shulker_box": "caja de shulker negra",
  "block.minecraft.white_glazed_terracotta": "azulejo blanco",
  "block.minecraft.orange_glazed_terracotta": "azulejo naranja",
  "block.minecraft.magenta_glazed_terracotta": "azulejo magenta",
  "block.minecraft.light_blue_glazed_terracotta": "azulejo celeste",
  "block.minecraft.yellow_glazed_terracotta": "azulejo amarillo",
  "block.minecraft.lime_glazed_terracotta": "azulejo verde lima",
  "block.minecraft.pink_glazed_terracotta": "azulejo rosa",
  "block.minecraft.gray_glazed_terracotta": "azulejo gris",
  "block.minecraft.light_gray_glazed_terracotta": "azulejo gris claro",
  "block.minecraft.cyan_glazed_terracotta": "azulejo cian",
  "block.minecraft.purple_glazed_terracotta": "azulejo violeta",
  "block.minecraft.blue_glazed_terracotta": "azulejo azul",
  "block.minecraft.brown_glazed_terracotta": "azulejo marrón",
  "block.minecraft.green_glazed_terracotta": "azulejo verde",
  "block.minecraft.red_glazed_terracotta": "azulejo rojo",
  "block.minecraft.black_glazed_terracotta": "azulejo negro",
  "block.minecraft.white_concrete": "concreto blanco",
  "block.minecraft.orange_concrete": "concreto naranja",
  "block.minecraft.magenta_concrete": "concreto magenta",
  "block.minecraft.light_blue_concrete": "concreto celeste",
  "block.minecraft.yellow_concrete": "concreto amarillo",
  "block.minecraft.lime_concrete": "concreto verde lima",
  "block.minecraft.pink_concrete": "concreto rosa",
  "block.minecraft.gray_concrete": "concreto gris",
  "block.minecraft.light_gray_concrete": "concreto gris claro",
  "block.minecraft.cyan_concrete": "concreto cian",
  "block.minecraft.purple_concrete": "concreto violeta",
  "block.minecraft.blue_concrete": "concreto azul",
  "block.minecraft.brown_concrete": "concreto marrón",
  "block.minecraft.green_concrete": "concreto verde",
  "block.minecraft.red_concrete": "concreto rojo",
  "block.minecraft.black_concrete": "concreto negro",
  "block.minecraft.white_concrete_powder": "cemento blanco",
  "block.minecraft.orange_concrete_powder": "cemento naranja",
  "block.minecraft.magenta_concrete_powder": "cemento magenta",
  "block.minecraft.light_blue_concrete_powder": "cemento celeste",
  "block.minecraft.yellow_concrete_powder": "cemento amarillo",
  "block.minecraft.lime_concrete_powder": "cemento verde lima",
  "block.minecraft.pink_concrete_powder": "cemento rosa",
  "block.minecraft.gray_concrete_powder": "cemento gris",
  "block.minecraft.light_gray_concrete_powder": "cemento gris claro",
  "block.minecraft.cyan_concrete_powder": "cemento cian",
  "block.minecraft.purple_concrete_powder": "cemento violeta",
  "block.minecraft.blue_concrete_powder": "cemento azul",
  "block.minecraft.brown_concrete_powder": "cemento marrón",
  "block.minecraft.green_concrete_powder": "cemento verde",
  "block.minecraft.red_concrete_powder": "cemento rojo",
  "block.minecraft.black_concrete_powder": "cemento negro",
  "block.minecraft.turtle_egg": "huevo de tortuga",
  "block.minecraft.dead_tube_coral_block": "bloque de coral de tubo muerto",
  "block.minecraft.dead_brain_coral_block": "bloque de coral de cerebro muerto",
  "block.minecraft.dead_bubble_coral_block": "bloque de coral de burbuja muerto",
  "block.minecraft.dead_fire_coral_block": "bloque de coral de fuego muerto",
  "block.minecraft.dead_horn_coral_block": "bloque de coral de cuerno muerto",
  "block.minecraft.tube_coral_block": "bloque de coral de tubo",
  "block.minecraft.brain_coral_block": "bloque de coral de cerebro",
  "block.minecraft.bubble_coral_block": "bloque de coral de burbuja",
  "block.minecraft.fire_coral_block": "bloque de coral de fuego",
  "block.minecraft.horn_coral_block": "bloque de coral de cuerno",
  "block.minecraft.tube_coral": "coral de tubo",
  "block.minecraft.brain_coral": "coral de cerebro",
  "block.minecraft.bubble_coral": "coral de burbuja",
  "block.minecraft.fire_coral": "coral de fuego",
  "block.minecraft.horn_coral": "coral de cuerno",
  "block.minecraft.dead_brain_coral": "coral de cerebro muerto",
  "block.minecraft.dead_bubble_coral": "coral de burbuja muerto",
  "block.minecraft.dead_fire_coral": "coral de fuego muerto",
  "block.minecraft.dead_horn_coral": "coral de cuerno muerto",
  "block.minecraft.dead_tube_coral": "coral de tubo muerto",
  "block.minecraft.tube_coral_fan": "gorgonia de tubo",
  "block.minecraft.brain_coral_fan": "gorgonia de cerebro",
  "block.minecraft.bubble_coral_fan": "gorgonia de burbuja",
  "block.minecraft.fire_coral_fan": "gorgonia de fuego",
  "block.minecraft.horn_coral_fan": "gorgonia de cuerno",
  "block.minecraft.dead_tube_coral_fan": "gorgonia de tubo muerta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia de cerebro muerta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia de burbuja muerta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de fuego muerta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia de cuerno muerta",
  "block.minecraft.blue_ice": "hielo azul",
  "block.minecraft.conduit": "canalizador",
  "block.minecraft.polished_granite_stairs": "escaleras de granito pulido",
  "block.minecraft.smooth_red_sandstone_stairs": "escaleras de arenisca rojiza lisa",
  "block.minecraft.mossy_stone_brick_stairs": "escaleras de ladrillos de piedra musgosos",
  "block.minecraft.polished_diorite_stairs": "escaleras de diorita pulida",
  "block.minecraft.mossy_cobblestone_stairs": "escaleras de adoquín musgoso",
  "block.minecraft.end_stone_brick_stairs": "escaleras de ladrillos de piedra del end",
  "block.minecraft.stone_stairs": "escaleras de piedra",
  "block.minecraft.smooth_sandstone_stairs": "escaleras de arenisca lisa",
  "block.minecraft.smooth_quartz_stairs": "escaleras de cuarzo liso",
  "block.minecraft.granite_stairs": "escaleras de granito",
  "block.minecraft.andesite_stairs": "escaleras de andesita",
  "block.minecraft.red_nether_brick_stairs": "escaleras de ladrillos del nether rojos",
  "block.minecraft.polished_andesite_stairs": "escaleras de andesita pulida",
  "block.minecraft.diorite_stairs": "escaleras de diorita",
  "block.minecraft.polished_granite_slab": "baldosa de granito pulido",
  "block.minecraft.smooth_red_sandstone_slab": "baldosa de arenisca rojiza lisa",
  "block.minecraft.mossy_stone_brick_slab": "baldosa de ladrillos de piedra musgosos",
  "block.minecraft.polished_diorite_slab": "baldosa de diorita pulida",
  "block.minecraft.mossy_cobblestone_slab": "baldosa de adoquín musgoso",
  "block.minecraft.end_stone_brick_slab": "baldosa de ladrillos de piedra del end",
  "block.minecraft.smooth_sandstone_slab": "baldosa de arenisca lisa",
  "block.minecraft.smooth_quartz_slab": "baldosa de cuarzo liso",
  "block.minecraft.granite_slab": "baldosa de granito",
  "block.minecraft.andesite_slab": "baldosa de andesita",
  "block.minecraft.red_nether_brick_slab": "baldosa de ladrillos del nether rojos",
  "block.minecraft.polished_andesite_slab": "baldosa de andesita pulida",
  "block.minecraft.diorite_slab": "baldosa de diorita",
  "block.minecraft.scaffolding": "andamio",
  "block.minecraft.iron_door": "puerta de hierro",
  "block.minecraft.oak_door": "puerta de roble",
  "block.minecraft.spruce_door": "puerta de abeto",
  "block.minecraft.birch_door": "puerta de abedul",
  "block.minecraft.jungle_door": "puerta de jungla",
  "block.minecraft.acacia_door": "puerta de acacia",
  "block.minecraft.dark_oak_door": "puerta de roble oscuro",
  "block.minecraft.crimson_door": "puerta carmesí",
  "block.minecraft.warped_door": "puerta distorsionada",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloque de estructuras",
  "block.minecraft.jigsaw": "bloque de rompecabezas",
  "item.minecraft.turtle_helmet": "caparazón de tortuga□□en la cabeza:□armadura: +2",
  "item.minecraft.scute": "escama de tortuga",
  "item.minecraft.iron_shovel": "pala de hierro□□en la mano principal:□daño por golpe: +3.5□velocidad de ataque: -3",
  "item.minecraft.iron_pickaxe": "pico de hierro□□en la mano principal:□daño por golpe: +3□velocidad de ataque: -2.8",
  "item.minecraft.iron_axe": "hacha de hierro□□en la mano principal:□daño por golpe: +8□velocidad de ataque: -3.1",
  "item.minecraft.flint_and_steel": "encendedor",
  "item.minecraft.apple": "manzana",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "flecha",
  "item.minecraft.coal": "carbón",
  "item.minecraft.charcoal": "carbón vegetal",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "lingote de hierro",
  "item.minecraft.gold_ingot": "lingote de oro",
  "item.minecraft.netherite_ingot": "lingote de netherita",
  "item.minecraft.netherite_scrap": "fragmento de netherita",
  "item.minecraft.iron_sword": "espada de hierro□□en la mano principal:□daño por golpe: +5□velocidad de ataque: -2.4",
  "item.minecraft.wooden_sword": "espada de madera□□en la mano principal:□daño por golpe: +3□velocidad de ataque: -2.4",
  "item.minecraft.wooden_shovel": "pala de madera□□en la mano principal:□daño por golpe: +1.5□velocidad de ataque: -3",
  "item.minecraft.wooden_pickaxe": "pico de madera□□en la mano principal:□daño por golpe: +1□velocidad de ataque: -2.8",
  "item.minecraft.wooden_axe": "hacha de madera□□en la mano principal:□daño por golpe: +6□velocidad de ataque: -3.2",
  "item.minecraft.stone_sword": "espada de piedra□□en la mano principal:□daño por golpe: +4□velocidad de ataque: -2.4",
  "item.minecraft.stone_shovel": "pala de piedra□□en la mano principal:□daño por golpe: +2.5□velocidad de ataque: -3",
  "item.minecraft.stone_pickaxe": "pico de piedra□□en la mano principal:□daño por golpe: +2□velocidad de ataque: -2.8",
  "item.minecraft.stone_axe": "hacha de piedra□□en la mano principal:□daño por golpe: +8□velocidad de ataque: -3.2",
  "item.minecraft.diamond_sword": "espada de diamante□□en la mano principal:□daño por golpe: +6□velocidad de ataque: -2.4",
  "item.minecraft.diamond_shovel": "pala de diamante□□en la mano principal:□daño por golpe: +4.5□velocidad de ataque: -3",
  "item.minecraft.diamond_pickaxe": "pico de diamante□□en la mano principal:□daño por golpe: +4□velocidad de ataque: -2.8",
  "item.minecraft.diamond_axe": "hacha de diamante□□en la mano principal:□daño por golpe: +8□velocidad de ataque: -3",
  "item.minecraft.stick": "palo",
  "item.minecraft.bowl": "bol",
  "item.minecraft.mushroom_stew": "guiso de hongos",
  "item.minecraft.golden_sword": "espada de oro□□en la mano principal:□daño por golpe: +3□velocidad de ataque: -2.4",
  "item.minecraft.golden_shovel": "pala de oro□□en la mano principal:□daño por golpe: +1.5□velocidad de ataque: -3",
  "item.minecraft.golden_pickaxe": "pico de oro□□en la mano principal:□daño por golpe: +1□velocidad de ataque: -2.8",
  "item.minecraft.golden_axe": "hacha de oro□□en la mano principal:□daño por golpe: +6□velocidad de ataque: -3",
  "item.minecraft.netherite_sword": "espada de netherita□□en la mano principal:□daño por golpe: +7□velocidad de ataque: -2.4",
  "item.minecraft.netherite_shovel": "pala de netherita□□en la mano principal:□daño por golpe: +5.5□velocidad de ataque: -3",
  "item.minecraft.netherite_pickaxe": "pico de netherita□□en la mano principal:□daño por golpe: +5□velocidad de ataque: -2.8",
  "item.minecraft.netherite_axe": "hacha de netherita□□en la mano principal:□daño por golpe: +9□velocidad de ataque: -3",
  "item.minecraft.string": "hilo",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "azada de madera□□en la mano principal:□velocidad de ataque: -3",
  "item.minecraft.stone_hoe": "azada de piedra□□en la mano principal:□velocidad de ataque: -2",
  "item.minecraft.iron_hoe": "azada de hierro□□en la mano principal:□velocidad de ataque: -1",
  "item.minecraft.diamond_hoe": "azada de diamante□□en la mano principal:",
  "item.minecraft.golden_hoe": "azada de oro□□en la mano principal:□velocidad de ataque: -3",
  "item.minecraft.netherite_hoe": "azada de netherita□□en la mano principal:",
  "item.minecraft.wheat_seeds": "semillas de trigo",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "gorro de cuero□□en la cabeza:□armadura: +1",
  "item.minecraft.leather_chestplate": "túnica de cuero□□en el torso:□armadura: +3",
  "item.minecraft.leather_leggings": "pantalones de cuero□□en las piernas:□armadura: +2",
  "item.minecraft.leather_boots": "botas de cuero□□en los pies:□armadura: +1",
  "item.minecraft.chainmail_helmet": "casco de cota de malla□□en la cabeza:□armadura: +2",
  "item.minecraft.chainmail_chestplate": "pechera de cota de malla□□en el torso:□armadura: +5",
  "item.minecraft.chainmail_leggings": "pantalones de cota de malla□□en las piernas:□armadura: +4",
  "item.minecraft.chainmail_boots": "botas de cota de malla□□en los pies:□armadura: +1",
  "item.minecraft.iron_helmet": "casco de hierro□□en la cabeza:□armadura: +2",
  "item.minecraft.iron_chestplate": "pechera de hierro□□en el torso:□armadura: +6",
  "item.minecraft.iron_leggings": "pantalones de hierro□□en las piernas:□armadura: +5",
  "item.minecraft.iron_boots": "botas de hierro□□en los pies:□armadura: +2",
  "item.minecraft.diamond_helmet": "casco de diamante□□en la cabeza:□armadura: +3□dureza de armadura: +2",
  "item.minecraft.diamond_chestplate": "pechera de diamante□□en el torso:□armadura: +8□dureza de armadura: +2",
  "item.minecraft.diamond_leggings": "pantalones de diamante□□en las piernas:□armadura: +6□dureza de armadura: +2",
  "item.minecraft.diamond_boots": "botas de diamante□□en los pies:□armadura: +3□dureza de armadura: +2",
  "item.minecraft.golden_helmet": "casco de oro□□en la cabeza:□armadura: +2",
  "item.minecraft.golden_chestplate": "pechera de oro□□en el torso:□armadura: +5",
  "item.minecraft.golden_leggings": "pantalones de oro□□en las piernas:□armadura: +3",
  "item.minecraft.golden_boots": "botas de oro□□en los pies:□armadura: +1",
  "item.minecraft.netherite_helmet": "casco de netherita□□en la cabeza:□armadura: +3□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_chestplate": "pechera de netherita□□en el torso:□armadura: +8□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_leggings": "pantalones de netherita□□en las piernas:□armadura: +6□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_boots": "botas de netherita□□en los pies:□armadura: +3□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.flint": "pedernal",
  "item.minecraft.porkchop": "chuleta cruda",
  "item.minecraft.cooked_porkchop": "chuleta cocinada",
  "item.minecraft.painting": "cuadro",
  "item.minecraft.golden_apple": "manzana dorada",
  "item.minecraft.enchanted_golden_apple": "manzana dorada encantada",
  "block.minecraft.oak_sign": "cartel de roble",
  "block.minecraft.spruce_sign": "cartel de abeto",
  "block.minecraft.birch_sign": "cartel de abedul",
  "block.minecraft.jungle_sign": "cartel de jungla",
  "block.minecraft.acacia_sign": "cartel de acacia",
  "block.minecraft.dark_oak_sign": "cartel de roble oscuro",
  "block.minecraft.crimson_sign": "cartel carmesí",
  "block.minecraft.warped_sign": "cartel distorsionado",
  "item.minecraft.bucket": "balde",
  "item.minecraft.water_bucket": "balde de agua",
  "item.minecraft.lava_bucket": "balde de lava",
  "item.minecraft.minecart": "carrito",
  "item.minecraft.saddle": "montura",
  "item.minecraft.redstone": "polvo de redstone",
  "item.minecraft.snowball": "bola de nieve",
  "item.minecraft.oak_boat": "bote de roble",
  "item.minecraft.leather": "cuero",
  "item.minecraft.milk_bucket": "balde de leche",
  "item.minecraft.pufferfish_bucket": "balde con pez globo",
  "item.minecraft.salmon_bucket": "balde con salmón",
  "item.minecraft.cod_bucket": "balde con bacalao",
  "item.minecraft.tropical_fish_bucket": "balde con pez tropical",
  "item.minecraft.brick": "ladrillo",
  "item.minecraft.clay_ball": "bola de arcilla",
  "block.minecraft.dried_kelp_block": "bloque de algas secas",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "bola de slime",
  "item.minecraft.chest_minecart": "carrito con cofre",
  "item.minecraft.furnace_minecart": "carrito con horno",
  "item.minecraft.egg": "huevo",
  "item.minecraft.compass": "brújula",
  "item.minecraft.fishing_rod": "caña de pescar",
  "item.minecraft.clock": "reloj",
  "item.minecraft.glowstone_dust": "polvo de piedra luminosa",
  "item.minecraft.cod": "bacalao crudo",
  "item.minecraft.salmon": "salmón crudo",
  "item.minecraft.tropical_fish": "pez tropical",
  "item.minecraft.pufferfish": "pez globo",
  "item.minecraft.cooked_cod": "bacalao cocinado",
  "item.minecraft.cooked_salmon": "salmón cocinado",
  "item.minecraft.ink_sac": "saco de tinta",
  "item.minecraft.red_dye": "tinte rojo",
  "item.minecraft.green_dye": "tinte verde",
  "item.minecraft.cocoa_beans": "granos de cacao",
  "item.minecraft.lapis_lazuli": "lapislázuli",
  "item.minecraft.purple_dye": "tinte violeta",
  "item.minecraft.cyan_dye": "tinte cian",
  "item.minecraft.light_gray_dye": "tinte gris claro",
  "item.minecraft.gray_dye": "tinte gris",
  "item.minecraft.pink_dye": "tinte rosa",
  "item.minecraft.lime_dye": "tinte verde lima",
  "item.minecraft.yellow_dye": "tinte amarillo",
  "item.minecraft.light_blue_dye": "tinte celeste",
  "item.minecraft.magenta_dye": "tinte magenta",
  "item.minecraft.orange_dye": "tinte naranja",
  "item.minecraft.bone_meal": "hueso molido",
  "item.minecraft.blue_dye": "tinte azul",
  "item.minecraft.brown_dye": "tinte marrón",
  "item.minecraft.black_dye": "tinte negro",
  "item.minecraft.white_dye": "tinte blanco",
  "item.minecraft.bone": "hueso",
  "item.minecraft.sugar": "azúcar",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "cama blanca",
  "block.minecraft.orange_bed": "cama naranja",
  "block.minecraft.magenta_bed": "cama magenta",
  "block.minecraft.light_blue_bed": "cama celeste",
  "block.minecraft.yellow_bed": "cama amarilla",
  "block.minecraft.lime_bed": "cama verde lima",
  "block.minecraft.pink_bed": "cama rosa",
  "block.minecraft.gray_bed": "cama gris",
  "block.minecraft.light_gray_bed": "cama gris claro",
  "block.minecraft.cyan_bed": "cama cian",
  "block.minecraft.purple_bed": "cama violeta",
  "block.minecraft.blue_bed": "cama azul",
  "block.minecraft.brown_bed": "cama marrón",
  "block.minecraft.green_bed": "cama verde",
  "block.minecraft.red_bed": "cama roja",
  "block.minecraft.black_bed": "cama negra",
  "item.minecraft.cookie": "galletita",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tijeras",
  "item.minecraft.melon_slice": "rebanada de sandía",
  "item.minecraft.dried_kelp": "algas secas",
  "item.minecraft.pumpkin_seeds": "semillas de zapallo",
  "item.minecraft.melon_seeds": "semillas de sandía",
  "item.minecraft.beef": "bife crudo",
  "item.minecraft.cooked_beef": "bife",
  "item.minecraft.chicken": "pollo crudo",
  "item.minecraft.cooked_chicken": "pollo cocinado",
  "item.minecraft.rotten_flesh": "carne podrida",
  "item.minecraft.ender_pearl": "perla de ender",
  "item.minecraft.blaze_rod": "vara de blaze",
  "item.minecraft.ghast_tear": "lágrima de ghast",
  "item.minecraft.gold_nugget": "pepita de oro",
  "item.minecraft.nether_wart": "verruga del nether",
  "item.minecraft.potion": "poción no fabricable□sin efectos",
  "item.minecraft.glass_bottle": "botella",
  "item.minecraft.spider_eye": "ojo de araña",
  "item.minecraft.fermented_spider_eye": "ojo de araña fermentado",
  "item.minecraft.blaze_powder": "polvo de blaze",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "destiladora",
  "block.minecraft.cauldron": "caldero",
  "item.minecraft.ender_eye": "ojo de ender",
  "item.minecraft.glistering_melon_slice": "rebanada de sandía brillante",
  "item.minecraft.bat_spawn_egg": "generar murciélago",
  "item.minecraft.bee_spawn_egg": "generar abeja",
  "item.minecraft.blaze_spawn_egg": "generar blaze",
  "item.minecraft.cat_spawn_egg": "generar gato",
  "item.minecraft.cave_spider_spawn_egg": "generar araña de cueva",
  "item.minecraft.chicken_spawn_egg": "generar gallina",
  "item.minecraft.cod_spawn_egg": "generar bacalao",
  "item.minecraft.cow_spawn_egg": "generar vaca",
  "item.minecraft.creeper_spawn_egg": "generar creeper",
  "item.minecraft.dolphin_spawn_egg": "generar delfín",
  "item.minecraft.donkey_spawn_egg": "generar burro",
  "item.minecraft.drowned_spawn_egg": "generar ahogado",
  "item.minecraft.elder_guardian_spawn_egg": "generar guardián mayor",
  "item.minecraft.enderman_spawn_egg": "generar enderman",
  "item.minecraft.endermite_spawn_egg": "generar endermite",
  "item.minecraft.evoker_spawn_egg": "generar invocador",
  "item.minecraft.fox_spawn_egg": "generar zorro",
  "item.minecraft.ghast_spawn_egg": "generar ghast",
  "item.minecraft.guardian_spawn_egg": "generar guardián",
  "item.minecraft.hoglin_spawn_egg": "generar hoglin",
  "item.minecraft.horse_spawn_egg": "generar caballo",
  "item.minecraft.husk_spawn_egg": "generar zombi momificado (husk)",
  "item.minecraft.llama_spawn_egg": "generar llama",
  "item.minecraft.magma_cube_spawn_egg": "generar cubo de magma",
  "item.minecraft.mooshroom_spawn_egg": "generar vaca mooshroom",
  "item.minecraft.mule_spawn_egg": "generar mula",
  "item.minecraft.ocelot_spawn_egg": "generar ocelote",
  "item.minecraft.panda_spawn_egg": "generar panda",
  "item.minecraft.parrot_spawn_egg": "generar loro",
  "item.minecraft.phantom_spawn_egg": "generar phantom",
  "item.minecraft.pig_spawn_egg": "generar chancho",
  "item.minecraft.piglin_spawn_egg": "generar piglin",
  "item.minecraft.pillager_spawn_egg": "generar saqueador",
  "item.minecraft.polar_bear_spawn_egg": "generar oso polar",
  "item.minecraft.pufferfish_spawn_egg": "generar pez globo",
  "item.minecraft.rabbit_spawn_egg": "generar conejo",
  "item.minecraft.ravager_spawn_egg": "generar devastador",
  "item.minecraft.salmon_spawn_egg": "generar salmón",
  "item.minecraft.sheep_spawn_egg": "generar oveja",
  "item.minecraft.shulker_spawn_egg": "generar shulker",
  "item.minecraft.silverfish_spawn_egg": "generar pez de plata",
  "item.minecraft.skeleton_spawn_egg": "generar esqueleto",
  "item.minecraft.skeleton_horse_spawn_egg": "generar caballo esqueleto",
  "item.minecraft.slime_spawn_egg": "generar slime",
  "item.minecraft.spider_spawn_egg": "generar araña",
  "item.minecraft.squid_spawn_egg": "generar calamar",
  "item.minecraft.stray_spawn_egg": "generar esqueleto glacial (stray)",
  "item.minecraft.strider_spawn_egg": "generar strider",
  "item.minecraft.trader_llama_spawn_egg": "generar llama de comerciante",
  "item.minecraft.tropical_fish_spawn_egg": "generar pez tropical",
  "item.minecraft.turtle_spawn_egg": "generar tortuga",
  "item.minecraft.vex_spawn_egg": "generar vex",
  "item.minecraft.villager_spawn_egg": "generar aldeano",
  "item.minecraft.vindicator_spawn_egg": "generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "generar comerciante nómada",
  "item.minecraft.witch_spawn_egg": "generar bruja",
  "item.minecraft.wither_skeleton_spawn_egg": "generar esqueleto del wither",
  "item.minecraft.wolf_spawn_egg": "generar lobo",
  "item.minecraft.zoglin_spawn_egg": "generar zoglin",
  "item.minecraft.zombie_spawn_egg": "generar zombi",
  "item.minecraft.zombie_horse_spawn_egg": "generar caballo zombi",
  "item.minecraft.zombie_villager_spawn_egg": "generar aldeano zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "generar piglin zombificado",
  "item.minecraft.experience_bottle": "botella de experiencia",
  "item.minecraft.fire_charge": "carga de fuego",
  "item.minecraft.writable_book": "libro y pluma",
  "item.minecraft.written_book": "libro escrito",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "marco",
  "block.minecraft.flower_pot": "maceta",
  "item.minecraft.carrot": "zanahoria",
  "item.minecraft.potato": "papa",
  "item.minecraft.baked_potato": "papa horneada",
  "item.minecraft.poisonous_potato": "papa venenosa",
  "item.minecraft.map": "mapa en blanco",
  "item.minecraft.golden_carrot": "zanahoria dorada",
  "block.minecraft.skeleton_skull": "cráneo de esqueleto",
  "block.minecraft.wither_skeleton_skull": "cráneo de esqueleto del wither",
  "block.minecraft.player_head": "cabeza de jugador",
  "block.minecraft.zombie_head": "cabeza de zombi",
  "block.minecraft.creeper_head": "cabeza de creeper",
  "block.minecraft.dragon_head": "cabeza de dragón",
  "item.minecraft.carrot_on_a_stick": "caña con zanahoria",
  "item.minecraft.warped_fungus_on_a_stick": "caña con hongo distorsionado",
  "item.minecraft.nether_star": "estrella del nether",
  "item.minecraft.pumpkin_pie": "tarta de zapallo",
  "item.minecraft.firework_rocket": "cohete",
  "item.minecraft.firework_star": "pólvora de cohete",
  "item.minecraft.enchanted_book": "libro encantado",
  "item.minecraft.nether_brick": "ladrillo del nether",
  "item.minecraft.quartz": "cuarzo del nether",
  "item.minecraft.tnt_minecart": "carrito con tnt",
  "item.minecraft.hopper_minecart": "carrito con tolva",
  "item.minecraft.prismarine_shard": "fragmento de prismarina",
  "item.minecraft.prismarine_crystals": "cristales de prismarina",
  "item.minecraft.rabbit": "conejo crudo",
  "item.minecraft.cooked_rabbit": "conejo cocinado",
  "item.minecraft.rabbit_stew": "guiso de conejo",
  "item.minecraft.rabbit_foot": "pata de conejo",
  "item.minecraft.rabbit_hide": "piel de conejo",
  "item.minecraft.armor_stand": "atril para armadura",
  "item.minecraft.iron_horse_armor": "armadura de hierro para caballo",
  "item.minecraft.golden_horse_armor": "armadura de oro para caballo",
  "item.minecraft.diamond_horse_armor": "armadura de diamante para caballo",
  "item.minecraft.leather_horse_armor": "armadura de cuero para caballo",
  "item.minecraft.lead": "soga",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "carrito con bloque de comandos",
  "item.minecraft.mutton": "cordero crudo",
  "item.minecraft.cooked_mutton": "cordero cocinado",
  "block.minecraft.white_banner": "estandarte blanco",
  "block.minecraft.orange_banner": "estandarte naranja",
  "block.minecraft.magenta_banner": "estandarte magenta",
  "block.minecraft.light_blue_banner": "estandarte celeste",
  "block.minecraft.yellow_banner": "estandarte amarillo",
  "block.minecraft.lime_banner": "estandarte verde lima",
  "block.minecraft.pink_banner": "estandarte rosa",
  "block.minecraft.gray_banner": "estandarte gris",
  "block.minecraft.light_gray_banner": "estandarte gris claro",
  "block.minecraft.cyan_banner": "estandarte cian",
  "block.minecraft.purple_banner": "estandarte violeta",
  "block.minecraft.blue_banner": "estandarte azul",
  "block.minecraft.brown_banner": "estandarte marrón",
  "block.minecraft.green_banner": "estandarte verde",
  "block.minecraft.red_banner": "estandarte rojo",
  "block.minecraft.black_banner": "estandarte negro",
  "item.minecraft.end_crystal": "cristal del end",
  "item.minecraft.chorus_fruit": "fruta de chorus",
  "item.minecraft.popped_chorus_fruit": "fruta de chorus horneada",
  "item.minecraft.beetroot": "remolacha",
  "item.minecraft.beetroot_seeds": "semillas de remolacha",
  "item.minecraft.beetroot_soup": "guiso de remolacha",
  "item.minecraft.dragon_breath": "aliento de dragón",
  "item.minecraft.splash_potion": "poción arrojadiza no fabricable□sin efectos",
  "item.minecraft.spectral_arrow": "flecha espectral",
  "item.minecraft.tipped_arrow": "flecha con efecto no fabricable□sin efectos",
  "item.minecraft.lingering_potion": "poción persistente no fabricable□sin efectos",
  "item.minecraft.shield": "escudo",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "bote de abeto",
  "item.minecraft.birch_boat": "bote de abedul",
  "item.minecraft.jungle_boat": "bote de jungla",
  "item.minecraft.acacia_boat": "bote de acacia",
  "item.minecraft.dark_oak_boat": "bote de roble oscuro",
  "item.minecraft.totem_of_undying": "tótem de inmortalidad",
  "item.minecraft.shulker_shell": "caparazón de shulker",
  "item.minecraft.iron_nugget": "pepita de hierro",
  "item.minecraft.knowledge_book": "enciclopedia",
  "item.minecraft.debug_stick": "palo debug",
  "item.minecraft.music_disc_13": "disco□c418 - 13",
  "item.minecraft.music_disc_cat": "disco□c418 - cat",
  "item.minecraft.music_disc_blocks": "disco□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disco□c418 - chirp",
  "item.minecraft.music_disc_far": "disco□c418 - far",
  "item.minecraft.music_disc_mall": "disco□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disco□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disco□c418 - stal",
  "item.minecraft.music_disc_strad": "disco□c418 - strad",
  "item.minecraft.music_disc_ward": "disco□c418 - ward",
  "item.minecraft.music_disc_11": "disco□c418 - 11",
  "item.minecraft.music_disc_wait": "disco□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disco□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□en la mano principal:□daño por golpe: +8□velocidad de ataque: -2.9",
  "item.minecraft.phantom_membrane": "membrana de phantom",
  "item.minecraft.nautilus_shell": "caparazón de nautilo",
  "item.minecraft.heart_of_the_sea": "corazón del mar",
  "item.minecraft.crossbow": "ballesta",
  "item.minecraft.suspicious_stew": "guiso sospechoso",
  "block.minecraft.loom": "máquina de telar",
  "item.minecraft.flower_banner_pattern": "diseño de estandarte□flor",
  "item.minecraft.creeper_banner_pattern": "diseño de estandarte□creeper",
  "item.minecraft.skull_banner_pattern": "diseño de estandarte□cráneo",
  "item.minecraft.mojang_banner_pattern": "diseño de estandarte□logotipo",
  "item.minecraft.globe_banner_pattern": "diseño de estandarte□planeta",
  "item.minecraft.piglin_banner_pattern": "diseño de estandarte□hocico",
  "block.minecraft.composter": "compostera",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "ahumador",
  "block.minecraft.blast_furnace": "alto horno",
  "block.minecraft.cartography_table": "mesa de cartografía",
  "block.minecraft.fletching_table": "mesa de arquería",
  "block.minecraft.grindstone": "afiladora",
  "block.minecraft.lectern": "atril",
  "block.minecraft.smithing_table": "mesa de herrería",
  "block.minecraft.stonecutter": "cortapiedras",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "farol",
  "block.minecraft.soul_lantern": "farol de almas",
  "item.minecraft.sweet_berries": "bayas dulces",
  "block.minecraft.campfire": "fogata",
  "block.minecraft.soul_campfire": "fogata de almas",
  "block.minecraft.shroomlight": "hongo luminoso",
  "item.minecraft.honeycomb": "panal",
  "block.minecraft.bee_nest": "colmena",
  "block.minecraft.beehive": "apiario",
  "item.minecraft.honey_bottle": "botella de miel",
  "block.minecraft.honey_block": "bloque de miel",
  "block.minecraft.honeycomb_block": "bloque de panal",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "bloque de netherita",
  "block.minecraft.ancient_debris": "escombros ancestrales",
  "block.minecraft.target": "diana",
  "block.minecraft.crying_obsidian": "obsidiana llorosa",
  "block.minecraft.blackstone": "piedra negra",
  "block.minecraft.blackstone_slab": "baldosa de piedra negra",
  "block.minecraft.blackstone_stairs": "escaleras de piedra negra",
  "block.minecraft.gilded_blackstone": "piedra negra dorada",
  "block.minecraft.polished_blackstone": "piedra negra pulida",
  "block.minecraft.polished_blackstone_slab": "baldosa de piedra negra pulida",
  "block.minecraft.polished_blackstone_stairs": "escaleras de piedra negra pulida",
  "block.minecraft.chiseled_polished_blackstone": "piedra negra pulida cincelada",
  "block.minecraft.polished_blackstone_bricks": "ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_slab": "baldosa de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_stairs": "escaleras de ladrillos de piedra negra pulida",
  "block.minecraft.cracked_polished_blackstone_bricks": "ladrillos de piedra negra pulida agrietada",
  "block.minecraft.respawn_anchor": "nexo de reaparición",
}
export const es_ar = items; 
